<template>
  <div class="enter-phone-number-modal relative">
    <BasePreloader v-if="loading" />

    <button
      class="enter-phone-number-modal__close"
      @click.prevent="close"
    >
      <BaseSvg name="ico-close" width="1.6rem" height="1.6rem" />
    </button>

    <div class="d-flex justify-center">
      <img
        src="@/assets/img/circles-check.webp"
        alt="message"
        style="object-fit: cover"
        class="modal-successfully-sent__img"
      >
    </div>

    <h1>{{ $tAuth('Enter code') }}</h1>

    <p>{{ $tAuth('Enter sent code to confirm') }}</p>

    <BaseInput
      v-model="code"
      :label="$tAuth('Code')"
      type="number"
    />

    <button
      class="base-btn base-btn--blue mt-5"
      :disabled="code.length < 6"
      @click="submit"
    >
      {{ $tVacancy('Submit') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'EnterCodeModal',
  props: {
    modalName: {
      type: String,
      default: '',
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      code: '',
      loading: false,
    };
  },
  methods: {
    submit() {
      this.loading = true;
      const dataOrPromise = this.onSubmit(this.code);
      if (dataOrPromise instanceof Promise) {
        dataOrPromise
          .catch(() => this.openErrorModal())
          .finally(() => this.loading = false);
      } else this.loading = false;
    },
    openErrorModal() {
      this.$vModal.open('warning', {
        title: this.$tAuth('Invalid value'),
        message: this.$tAuth('You passed invalid value'),
      });
    },
    close() {
      this.$vModal.close(this.modalName)
    },
  },
};
</script>
